import { users } from "@api/courses/stats/users/api";

export const stats = {
  users,
};
